// Section 5 and 15: Fertile. Conception chance 1.5x for the couple (the mother and her partner
// when the target names the mother; otherwise any member of the household). Constants: config.traits.fertile.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { neverRestricts } from '../../core/content-helpers';
import { defineTrait } from '../../core/registry';

export function fertile(config: Config) {
  return defineTrait({
    id: 'fertile',
    label: 'Fertile',
    section: 'S5',
    modifierTargets: ['conception'],
    modifiers(ctx, target) {
      if (target.kind !== 'conception') return [];
      const mother = target.motherId === undefined ? undefined : ctx.state.people[target.motherId];
      const ids =
        mother === undefined
          ? (ctx.state.households[target.householdId]?.memberIds ?? [])
          : [mother.id, ...(mother.partnerId === null ? [] : [mother.partnerId])];
      const any = ids.some((id) => ctx.state.people[id]?.traits.includes('fertile') === true);
      return any ? [mod.mul('trait:fertile', config.traits.fertile.conceptionMul, 'fertile')] : [];
    },
    restricts: neverRestricts,
  });
}
